import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { DeleteParticipantFieldTemplate } from '../mutations/deleteParticipantFieldTemplate.mutation';
import type {
  DeleteParticipantFieldTemplateMutation,
  DeleteParticipantFieldTemplateMutationVariables,
} from '../types';

export const useDeleteParticipantFieldTemplateMutation = (
  options?: MutationOptions<
    DeleteParticipantFieldTemplateMutation,
    DeleteParticipantFieldTemplateMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(DeleteParticipantFieldTemplate), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participantFieldGroupTemplate'),
      });
    },
  });
};
